var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.92C14.24 14.92 13.56 15.22 13.04 15.69L5.91 11.54C5.96 11.31 6 11.08 6 10.84C6 10.6 5.96 10.37 5.91 10.14L12.96 6.02997C13.5 6.52997 14.21 6.83997 15 6.83997C16.66 6.83997 18 5.49997 18 3.83997C18 2.17997 16.66 0.839966 15 0.839966C13.34 0.839966 12 2.17997 12 3.83997C12 4.07997 12.04 4.30997 12.09 4.53997L5.04 8.64997C4.5 8.14997 3.79 7.83997 3 7.83997C1.34 7.83997 0 9.17997 0 10.84C0 12.5 1.34 13.84 3 13.84C3.79 13.84 4.5 13.53 5.04 13.03L12.16 17.19C12.11 17.4 12.08 17.62 12.08 17.84C12.08 19.45 13.39 20.76 15 20.76C16.61 20.76 17.92 19.45 17.92 17.84C17.92 16.23 16.61 14.92 15 14.92Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid11);
export default __webpack_public_path__ + "static/media/grid11.523124c299a460a349d7d3cafb189aae.svg";
export { ForwardRef as ReactComponent };